import Configslayout from "@/layout/config_base_layout/ConfigsLayout.vue";
import LandCourtHome from "@/views/land_court_views/LandCourtHome/LandCourtHome.vue";
import LandCourtOverview from "@/views/land_court_views/LandCourtOverview/LandCourtOverview.vue";
import ViewCaseDetails from "@/views/land_court_views/ViewCaseDetails/ViewCaseDetails.vue";

const land_court_routes = [
  {
    path: "/",
    component: Configslayout,
    children: [
      {
        path: "/land-court-overview",
        name: "LandCourtOverview",
        component: LandCourtOverview
      },
      {
        path: "/land-court-home",
        name: "LandCourtHome",
        component: LandCourtHome
      },
      {
        path: "/land-court-case/:applicationId",
        name: "ViewCaseDetails",
        component: ViewCaseDetails
      }
    ]
  }
];

export default land_court_routes;
